import _ from 'lodash'
import React from 'react'
import Scrollbars from 'react-custom-scrollbars-2'
import styles from './ProductFilterList.module.scss'
import { ActiveFiltersInterface, ProductFiltersInterface } from '../../../interfaces/FiltersInterface'
import { PRODUCT_ATTRIBUTE_IDS } from '../../../utils/product'
import { SINGLE_VALUE_ATTRIBUTES } from '../../../utils/productFilter'
import FormattedMessage from '../../FormattedMessage/FormattedMessage'
import { hasActiveFilters } from '../../OldProductFilter/productFilterUtils'
import ProductFilterAttribute, { FILTER_BUTTON_SIZE } from '../ProductFilterAttribute/ProductFilterAttribute'
import ProductFilterChips from '../ProductFilterChips/ProductFilterChips'
import ProductFilterPriceRange from '../ProductFilterPriceRange/ProductFilterPriceRange'
import ProductFilterSize from '../ProductFilterSize/ProductFilterSize'

interface Props {
  filters: ProductFiltersInterface
  activeFilters: ActiveFiltersInterface
  onFlatAttributeChange: (name: string, valueId: number | string, checked: boolean) => void
  onAttributeChange: (attributeId: number, valueId: number, checked: boolean) => void
  onRangeChanged: (attributeId: string, minValue: string | null, maxValue: string | null, extra?: object) => void
}

const ProductFilterList: React.FC<Props> = (props: Props) => {
  const attributeFilters = props.filters.attributes
    .filter(attribute => attribute.values.length > 1 || (SINGLE_VALUE_ATTRIBUTES.includes(attribute.id) && attribute.values.length > 0))
    .map(attribute => {
      const activeValues = props.activeFilters.attributes?.[attribute.id] || {}
      const value: number[] = []
      for (const key in activeValues) {
        if (+activeValues[key]) {
          value.push(+key)
        }
      }
      return (
        <ProductFilterAttribute
          key={`product-filter-attribute-${attribute.id}`}
          attribute={attribute}
          selectedValues={value}
          onSelectionChange={props.onAttributeChange}
          buttonSize={
            [PRODUCT_ATTRIBUTE_IDS.STYLE, PRODUCT_ATTRIBUTE_IDS.FEATURE].includes(attribute.id)
              ? FILTER_BUTTON_SIZE.LARGE
              : FILTER_BUTTON_SIZE.NORMAL
          }
        />
      )
    })

  return (
    <Scrollbars hideTracksWhenNotNeeded={false}>
      {hasActiveFilters(props.activeFilters) ? (
        <div className={styles['selected_filters__container']}>
          <FormattedMessage
            id="ProductFilter.SelectedFilters"
            defaultMessage="Selected Filters"
            className={styles['selected_filters__title']}
          />
          <ProductFilterChips
            filters={props.filters}
            activeFilters={props.activeFilters}
            onRangeChanged={props.onRangeChanged}
            onFlatAttributeChange={props.onFlatAttributeChange}
            onAttributeChange={props.onAttributeChange}
          />
        </div>
      ) : null}
      {props.filters.sizes.length > 0 ? (
        <ProductFilterSize
          sizes={props.filters.sizes}
          selectedValues={props.activeFilters.sizeKeys || []}
          onSelectionChange={props.onFlatAttributeChange}
        />
      ) : null}
      {attributeFilters}
      <ProductFilterPriceRange
        min={props.activeFilters.price?.min || null}
        max={props.activeFilters.price?.max || null}
        saleItems={props.activeFilters.price?.saleItems === '1'}
        onChange={props.onRangeChanged}
      />
    </Scrollbars>
  )
}

export default ProductFilterList
